import { Select } from "antd";
import type { PhysicianListItem } from "@/portals/physician/api/types";
import { physicianName } from "@/portals/physician/lib/physicianName";

interface PhysicianPickerProps {
  physicians: PhysicianListItem[];
  value: string | undefined;
  onChange: (userId: string) => void;
  /** A physician not to offer (e.g. the one already assigned). */
  excludeUserId?: string;
}

/** Searchable physician select — shared by patient assignment (Module 4) and queue assignment (Module 6). */
export function PhysicianPicker({ physicians, value, onChange, excludeUserId }: PhysicianPickerProps) {
  return (
    <Select
      aria-label="Physician"
      className="!w-full"
      placeholder="Select a physician"
      value={value}
      onChange={onChange}
      showSearch
      optionFilterProp="label"
      options={physicians
        .filter((p) => p.userId !== excludeUserId)
        .map((p) => ({ value: p.userId, label: physicianName(p) === p.email ? p.email : `${physicianName(p)} · ${p.email}` }))}
    />
  );
}
